import React, { useState, useRef, useEffect } from 'react';

const ClientSearchSelect = ({ onSelectClient, disabled }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const searchTimer = useRef(null);
  const wrapperRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (value) => {
    setQuery(value);
    if (searchTimer.current) clearTimeout(searchTimer.current);

    if (value.length < 2) {
      setResults([]);
      setIsOpen(false);
      return;
    }

    setIsLoading(true);
    searchTimer.current = setTimeout(async () => {
      try {
        const { soaBuilderAPI } = await import('../../../services/api');
        const data = await soaBuilderAPI.searchClients(value);
        setResults(data);
        setIsOpen(true);
      } catch (err) {
        console.error('Client search failed:', err);
        setResults([]);
      } finally {
        setIsLoading(false);
      }
    }, 300);
  };

  const handleSelect = (client) => {
    onSelectClient(client);
    setQuery('');
    setResults([]);
    setIsOpen(false);
  };

  return (
    <div className="soa-client-search" ref={wrapperRef} style={{ position: 'relative', marginBottom: '1rem' }}>
      <div className="d-flex align-items-center gap-2">
        <i className="bi bi-search" style={{ color: 'var(--gray-color)' }}></i>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Search existing clients by name..."
          value={query}
          onChange={(e) => handleSearch(e.target.value)}
          disabled={disabled}
          style={{ maxWidth: '350px' }}
        />
        {isLoading && <span className="spinner-border spinner-border-sm text-muted"></span>}
      </div>

      {isOpen && results.length > 0 && (
        <div className="soa-client-dropdown">
          {results.map((client) => (
            <button
              key={client.id}
              type="button"
              className="soa-client-dropdown-item"
              onClick={() => handleSelect(client)}
            >
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <span className="fw-bold">{client.full_name}</span>
                  {client.email && <span className="text-muted ms-2 small">{client.email}</span>}
                </div>
                {client.date_of_birth && (
                  <small className="text-muted">{client.date_of_birth}</small>
                )}
              </div>
            </button>
          ))}
        </div>
      )}

      {isOpen && results.length === 0 && query.length >= 2 && !isLoading && (
        <div className="soa-client-dropdown">
          <div className="text-muted small p-2 text-center">No clients found</div>
        </div>
      )}
    </div>
  );
};

export default ClientSearchSelect;
